import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";
import Icons from "assets/icons";
import Icon from "@ant-design/icons";
import React from "react";

const {RADIO_BUTTON, INPUT, CHECKBOX} = FIELD_TYPE;

const labelCol = {xs: 6, md: 6, lg: 6};
const wrapperCol = {xs: 18, md: 18, lg: 18};
const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};

const fieldsInjuryRight: Array<DataFormField> = [
  {
    name: ["rightJsonValue", "INJURY", "Hình dáng chấn thương"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Tình trạng nhãn cầu:",
    radioButtons: [
      {
        label: "Chấn thương nhãn cầu hở",
        value: "Chấn thương nhãn cầu hở",
        span: 12,
      },
      {
        label: "Chấn thương nhãn cầu kín",
        value: "Chấn thương nhãn cầu kín",
        span: 12,
      },
    ],
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "INJURY", "show"],
    hide: true,
  },
];
const fieldsInjuryLeft: Array<DataFormField> = [
  {
    name: ["leftJsonValue", "INJURY", "Hình dáng chấn thương"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Tình trạng nhãn cầu:",
    radioButtons: [
      {
        label: "Chấn thương nhãn cầu hở",
        value: "Chấn thương nhãn cầu hở",
        span: 12,
      },
      {
        label: "Chấn thương nhãn cầu kín",
        value: "Chấn thương nhãn cầu kín",
        span: 12,
      },
    ],
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "INJURY", "show"],
    hide: true,
  },
];

const fieldsOpenGlobeRight: any[] = [
  {
    name: ["rightJsonValue", "INJURY", "OpenGlobeInjuries"],
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chấn thương nhãn cầu hở:",
    checkbox: [
      {
        label: "Chấn thương đụng dập",
        value: "Chấn thương đụng dập",
        span: 8,
      },
      {
        label: "Thủng nhãn cầu",
        value: "Thủng nhãn cầu",
        span: 8,
      },
      {
        label: "Dị vật nội nhãn",
        value: "Dị vật nội nhãn",
        span: 8,
      },

      {
        label: "Chấn thương kết hợp",
        value: "Chấn thương kết hợp",
        span: 12,
      },
    ],
  },
];
const fieldsOpenGlobeLeft: any[] = [
  {
    name: ["leftJsonValue", "INJURY", "OpenGlobeInjuries"],
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chấn thương nhãn cầu hở:",
    checkbox: [
      {
        label: "Chấn thương đụng dập",
        value: "Chấn thương đụng dập",
        span: 8,
      },

      {
        label: "Dị vật nội nhãn",
        value: "Dị vật nội nhãn",
        span: 8,
      },
      {
        label: "Thủng nhãn cầu",
        value: "Thủng nhãn cầu",
        span: 12,
      },
      {
        label: "Chấn thương kết hợp",
        value: "Chấn thương kết hợp",
        span: 12,
      },
    ],
  },
];
const fieldsClosedGlobeRight: any[] = [
  {
    name: ["rightJsonValue", "INJURY", "ClosedGlobeInjuries"],
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chấn thương nhãn cầu kín:",
    checkbox: [
      {
        label: "Bầm tím",
        value: "Bầm tím",
        span: 12,
      },
      {
        label: "Rách tách lớp",
        value: "Rách tách lớp",
        span: 12,
      },
      {
        label: "Dị vật nông",
        value: "Dị vật nông",
        span: 12,
      },
      {
        label: "Thủng nhãn cầu",
        value: "Thủng nhãn cầu",
        span: 8,
      },
      {
        label: "Chấn thương kết hợp",
        value: "Chấn thương kết hợp",
        span: 8,
      },
    ],
  },
];
const fieldsClosedGlobeLeft: any[] = [
  {
    name: ["leftJsonValue", "INJURY", "ClosedGlobeInjuries"],
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chấn thương nhãn cầu kín:",
    checkbox: [
      {
        label: "Bầm tím",
        value: "Bầm tím",
        span: 12,
      },
      {
        label: "Rách tách lớp",
        value: "Rách tách lớp",
        span: 12,
      },
      {
        label: "Dị vật nông",
        value: "Dị vật nông",
        span: 12,
      },
      {
        label: "Thủng nhãn cầu",
        value: "Thủng nhãn cầu",
        span: 8,
      },
      {
        label: "Chấn thương kết hợp",
        value: "Chấn thương kết hợp",
        span: 8,
      },
    ],
  },
];

const fieldsRuptureRight: any[] = [
  {
    name: ["rightJsonValue", "INJURY", "Chấn thương đụng dập"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chấn thương đụng dập:",
    radioButtons: [
      {
        label: "Viêm mủ nội nhãn",
        value: "Viêm mủ nội nhãn",
        span: 12,
      },
      {
        label: "Viêm mủ toàn nhãn",
        value: "Viêm mủ toàn nhãn",
        span: 12,
      },
    ],
  },
];
const fieldsLamellarRight: Array<DataFormField> = [
  {
    name: ["rightJsonValue", "INJURY", "Rách tách lớp"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: " ",
    radioButtons: [
      {
        label: "External(Limited to Bulbar Conjunctiva, Sclera, Cornea)",
        value: "External(Limited to Bulbar Conjunctiva, Sclera, Cornea)",
        span: 24,
      },
      {
        label:
          "Anterior Segment(Involving Structures Internal to Corneal like AC, Lens, Posterior Capsule, Pars Plicata)",
        value:
          "Anterior Segment(Involving Structures Internal to Corneal like AC, Lens, Posterior Capsule, Pars Plicata)",
        span: 24,
      },
      {
        label: "Structures Posterior to Posterior Lens",
        value: "Structures Posterior to Posterior Lens",
        span: 24,
      },
    ],
  },
];
const fieldsLamellarLeft: Array<DataFormField> = [
  {
    name: ["leftJsonValue", "INJURY", "Rách tách lớp"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: " ",
    radioButtons: [
      {
        label: "External(Limited to Bulbar Conjunctiva, Sclera, Cornea)",
        value: "External(Limited to Bulbar Conjunctiva, Sclera, Cornea)",
        span: 24,
      },
      {
        label:
          "Anterior Segment(Involving Structures Internal to Corneal like AC, Lens, Posterior Capsule, Pars Plicata)",
        value:
          "Anterior Segment(Involving Structures Internal to Corneal like AC, Lens, Posterior Capsule, Pars Plicata)",
        span: 24,
      },
      {
        label: "Structures Posterior to Posterior Lens",
        value: "Structures Posterior to Posterior Lens",
        span: 24,
      },
    ],
  },
];
const fieldsRuptureLeft: any[] = [
  {
    name: ["leftJsonValue", "INJURY", "Chấn thương đụng dập"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    label: "Chấn thương đụng dập:",
    radioButtons: [
      {
        label: "Viêm mủ nội nhãn",
        value: "Viêm mủ nội nhãn",
        span: 12,
      },
      {
        label: "Viêm mủ toàn nhãn",
        value: "Viêm mủ toàn nhãn",
        span: 12,
      },
    ],
  },
];
const fieldsIOFBRight: any[] = [
  {
    name: ["rightJsonValue", "INJURY", "Dị vật nội nhãn"],
    label: "Dị vật nội nhãn",
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    checkbox: [
      {
        label: "Gỗ",
        value: "Gỗ",
        span: 12,
      },
      {
        label: "Đá",
        value: "Đá",
        span: 12,
      },
      {
        label: "Thực vật",
        value: "Thực vật",
        span: 12,
      },
      {
        label: "Phi kim",
        value: "Phi kim",
        span: 12,
      },
      {
        label: "Thủy tinh",
        value: "Thủy tinh",
        span: 12,
      },
    ],
  },
];
const fieldsIOFBLeft: any[] = [
  {
    name: ["leftJsonValue", "INJURY", "Dị vật nội nhãn"],
    label: "Dị vật nội nhãn",
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    checkbox: [
      {
        label: "Gỗ",
        value: "Gỗ",
        span: 8,
      },
      {
        label: "Đá",
        value: "Đá",
        span: 8,
      },
      {
        label: "Thực vật",
        value: "Thực vật",
        span: 8,
      },
      {
        label: "Phi kim",
        value: "Phi kim",
        span: 12,
      },
      {
        label: "Thủy tinh",
        value: "Thủy tinh",
        span: 12,
      },
    ],
  },
];
const fieldsStoneRight: any[] = [
  {
    name: ["rightJsonValue", "INJURY", "Đá"],
    label: " ",
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    checkbox: [
      {
        label: "Liên quan giác mạc",
        value: "Liên quan giác mạc",
        span: 24,
      },
      {
        label: "Liên quan củng mạc",
        value: "Liên quan củng mạc",
        span: 24,
      },
      {
        label: "Sau ra trước củng mạc 5mm",
        value: "Sau ra trước củng mạc 5mm",
        span: 24,
      },
    ],
  },
];
const fieldsStoneLeft: any[] = [
  {
    name: ["leftJsonValue", "INJURY", "Đá"],
    label: " ",
    type: CHECKBOX,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    checkbox: [
      {
        label: "Liên quan giác mạc",
        value: "Liên quan giác mạc",
        span: 24,
      },
      {
        label: "Liên quan củng mạc",
        value: "Liên quan củng mạc",
        span: 24,
      },
      {
        label: "Sau ra trước củng mạc 5mm",
        value: "Sau ra trước củng mạc 5mm",
        span: 24,
      },
    ],
  },
];
const fieldsCommentRight = [
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["rightJsonValue", "INJURY", "Ghi chú"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},

    suffix: (
      <Icon
        style={{fontSize: "24px"}}
        component={Icons.file as React.ForwardRefExoticComponent<any>}
      />
    ),
  },
];
const fieldsCommentLeft = [
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "INJURY", "Ghi chú"],
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},

    suffix: (
      <Icon
        style={{fontSize: "24px"}}
        component={Icons.file as React.ForwardRefExoticComponent<any>}
      />
    ),
  },
];

export {
  fieldsInjuryLeft,
  fieldsInjuryRight,
  fieldsOpenGlobeRight,
  fieldsOpenGlobeLeft,
  fieldsClosedGlobeLeft,
  fieldsClosedGlobeRight,
  fieldsLamellarRight,
  fieldsLamellarLeft,
  fieldsRuptureRight,
  fieldsRuptureLeft,
  fieldsIOFBRight,
  fieldsIOFBLeft,
  fieldsStoneRight,
  fieldsStoneLeft,
  fieldsCommentLeft,
  fieldsCommentRight,
};
